// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".device-report-header[data-v-43d36dcc]{font-size:18px;font-weight:600}.graph-header[data-v-43d36dcc]{font-size:14px;font-weight:600}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
